import React, { useReducer } from 'react';
import PacientesContext from './pacientesContext';
import PacientesReducer from './pacientesReducer';

const PacientesState = ( props ) => {

    const initialState = {
    }

    const [ state, dispatch ] = useReducer( PacientesReducer, initialState );
    
    return ( 
        <PacientesContext.Provider>
            {props.children}
        </PacientesContext.Provider>
     );
}
 
export default PacientesState;